import { api } from "services"

export async function getWarehouseMembers() {
  const { data } = await api.get("/company-members?asList=1")
  
  return data
}